export default __webpack_public_path__ + "static/media/idna-ecommerce-misc.a29ee61c.jpg";